import { render, staticRenderFns } from "./PrintBalanceEntryReciept.vue?vue&type=template&id=2e23bad8&scoped=true&"
import script from "./PrintBalanceEntryReciept.vue?vue&type=script&lang=js&"
export * from "./PrintBalanceEntryReciept.vue?vue&type=script&lang=js&"
import style0 from "./PrintBalanceEntryReciept.vue?vue&type=style&index=0&id=2e23bad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23bad8",
  null
  
)

export default component.exports